<template>
  <validationProvider
    rules="max:400"
    v-slot="{ errors, valid }"
    immediate
    name="ドイツ語を勉強している目的や目標"
  >
    <p>
      <FormTitleText titleText="ドイツ語を勉強している目的や目標" />
      <FormAttentionText :attentionText="$t('profile.max400')" />
    </p>
    <v-textarea
      v-model="inputedLearningGoal"
      placeholder=""
      outlined
      background-color="white"
      counter
      :success="valid"
    ></v-textarea>
    <FormErrorText :errorText="errors[0]" />
  </validationProvider>
</template>

<script>
import FormTitleText from '../Atoms/FormTitleText';
import FormErrorText from '../Atoms/FormErrorText';
import FormAttentionText from '../Atoms/FormAttentionText';

export default {
  name: 'LearningGoalForm',
  data: () => ({
  }),
  props: ['value'],
  mounted() {
  },
  computed: {
    inputedLearningGoal: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
  },
  methods: {
  },
  components: {
    FormTitleText,
    FormErrorText,
    FormAttentionText
  }
};
</script>

<style lang="scss" scoped>
</style>
